import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.477 20H.33V6.647h4.147V20zM2.4 4.825C1.075 4.825 0 3.727 0 2.401a2.401 2.401 0 114.803 0c0 1.326-1.076 2.424-2.402 2.424zM19.996 20h-4.138v-6.5c0-1.55-.031-3.536-2.156-3.536-2.156 0-2.486 1.683-2.486 3.424V20H7.074V6.647h3.977v1.821h.058c.553-1.049 1.906-2.156 3.923-2.156C19.23 6.312 20 9.075 20 12.665V20h-.005z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}